import { render, staticRenderFns } from "./CompaniesTableHeader.vue?vue&type=template&id=03f60895"
import script from "./CompaniesTableHeader.vue?vue&type=script&lang=js"
export * from "./CompaniesTableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports